<template>
  <div>
    <datatable
      title="Applicant Languages"
      @create="createLanguage"
      @delete="deleteLanguage"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-languages',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'language_name',
          value: 'language.name'
        },
        {
          name: 'reading',
          value: 'reading'
        },
        {
          name: 'writing',
          value: 'writing'
        },
        {
          name: 'verbal',
          value: 'verbal'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getApplicantLanguages({
          current_applicant_id: this.applicant_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteLanguage (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.language.name,
        item_name: delete_data.language.name,
        method: 'deleteApplicantLanguage',
        method_params: { id: delete_data.id, current_applicant_id: this.applicant_id }
      })
    },
    createLanguage () {
      this.create({ designator: 'applicant-languages-form-modal', component_name: 'ApplicantLanguagesForm', is_create: true, applicant_id: this.applicant_id, modal_title: 'Create new Language' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-languages-form-modal', component_name: 'ApplicantLanguagesForm', data, applicant_id: this.applicant_id, modal_title: data.language.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
